import { createSelector } from 'reselect'
import { getCruiseItems, hasLuxPlusInclusionsInCruiseBooking, getCurrentCheckoutStepId as getCruiseCheckoutStepId } from './cruiseSelectors'
import { getTourCheckoutSteps } from 'components/App/Header/HeaderCheckout/StepsHeaderCheckout/steps/tours'
import { CRUISE_CHECKOUT_HEADER_STEPS } from 'components/App/Header/HeaderCheckout/StepsHeaderCheckout/steps/cruises'
import { getCheckoutRouteFromURL } from 'checkout/lib/utils/misc/steps'
import { EmptyArray } from 'lib/array/arrayUtils'
import { CheckoutPageId } from 'checkout/constants/pages'
import { checkCanRedeemLuxPlusBenefits, isLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'

export const selectCheckoutSteps = createSelector(
  (state: App.State) => getTourCheckoutSteps(state),
  (state: App.State) => getCruiseItems(state),
  (state: App.State) => isLuxPlusEnabled(state),
  (state: App.State) => checkCanRedeemLuxPlusBenefits(state),
  (state: App.State) => hasLuxPlusInclusionsInCruiseBooking(state),
  (
    tourCheckoutSteps,
    cruiseItems,
    luxPlusEnabled,
    checkCanRedeemLuxPlusBenefits,
    hasLuxPlusInclusionsInCruiseBooking,
  ): Array<App.Checkout.CheckoutStep> => {
    const isCruise = cruiseItems.length > 0
    const cruiseStepsExcludingLuxPlus = CRUISE_CHECKOUT_HEADER_STEPS.filter(step => step.key !== CheckoutPageId.LuxPlus)

    if (isCruise) {
      if (!luxPlusEnabled || !hasLuxPlusInclusionsInCruiseBooking || checkCanRedeemLuxPlusBenefits) {
        return cruiseStepsExcludingLuxPlus
      }
      return CRUISE_CHECKOUT_HEADER_STEPS
    }

    if (tourCheckoutSteps.length > 1) {
      return tourCheckoutSteps
    }

    return EmptyArray
  },
)

export const selectCheckoutCurrentStep = createSelector(
  (state: App.State) => state.router.location,
  (state: App.State) => getCruiseCheckoutStepId(state),
  (state: App.State) => getTourCheckoutSteps(state),
  (state: App.State) => getCruiseItems(state),
  (state: App.State) => selectCheckoutSteps(state),
  (
    location,
    cruiseCheckoutStepId,
    tourCheckoutSteps,
    cruiseItems,
    steps,
  ): App.Checkout.CheckoutStep | undefined => {
    const isCruise = cruiseItems.length > 0

    let stepKey: string | undefined
    if (isCruise) {
      stepKey = cruiseCheckoutStepId
    }

    if (tourCheckoutSteps.length > 1) {
      stepKey = getCheckoutRouteFromURL(location.pathname)
    }

    return steps.find(step => {
      return step.key === stepKey ||
        // if any sub-step matches the current key, we pick the parent as the current active step.
        step.subSteps?.some(subStep => subStep.key === stepKey)
    })
  },
)
